import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import CheckGreen from '../../../../../assets/icons/check-green.svg';
import CloseIcon from '../../../../../assets/icons/close-red.svg';
import { getPaySystemName } from '../../../../../utils/cashier';

import { container } from './DocumentRequirements.scss';
import DocumentsGroup from './DocumentsGroup/DocumentsGroup';
import { defaultMessages, translationMap } from './utils/translationUtils';

const DocumentRequirements: React.FC = () => {
  const {
    data: { paySystems },
    values: {
      deposit: { type }
    }
  } = useWizardContext();

  const i18nSystemName = getPaySystemName(paySystems, type);
  const { acceptedDocuments, requiredDocuments } = translationMap[type] || defaultMessages;

  return (
    <div className={container}>
      <DocumentsGroup
        title={acceptedDocuments.title}
        options={acceptedDocuments.options}
        i18nSystemName={i18nSystemName}
        icon={<CheckGreen />}
      />
      <DocumentsGroup
        title={requiredDocuments.title}
        options={requiredDocuments.options}
        i18nSystemName={i18nSystemName}
        icon={<CloseIcon />}
      />
    </div>
  );
};

DocumentRequirements.displayName = 'DocumentRequirements';

export default DocumentRequirements;
